import React, { FC } from 'react';
import { ImageDataLike } from 'gatsby-plugin-image';
import format from 'date-fns/format';
import { CareersNewsFeedFragment } from '../types/graphqlTypes';
import { Card } from './Card';
import { CardCarouselWrapper } from './CardCarouselWrapper';
import { Section } from './Section';

interface CareersNewsFeedProps extends CareersNewsFeedFragment {
  width: 'narrow' | 'wide';
}

export const CareersNewsFeed: FC<Omit<CareersNewsFeedProps, '__typename'>> = ({
  title,
  careersNews,
  width,
  backgroundColour,
}) => {
  if (careersNews.length === 0) {
    return null;
  }

  return (
    <Section
      contained
      background={backgroundColour || 'grey'}
      customButton={{
        label: 'View all KFH Life news',
        url: `/careers/careers-news/`,
        variant: 'solid',
        arrowRight: true,
      }}
      narrow={width === 'narrow'}
      overflowHidden
    >
      <CardCarouselWrapper heading={title} width={width}>
        {careersNews.map(({ pageName, feed, relativeUrl, publishDate }, index) => (
          <Card
            key={index}
            image={feed.featuredImage?.localFile as unknown as ImageDataLike}
            heading={feed.shortTitle ? feed.shortTitle : pageName}
            meta={format(new Date(publishDate as Date), 'dd/MM/yyyy')}
            url={relativeUrl}
            actionLabel="Read more"
            backgroundColor={backgroundColour === 'white' || !backgroundColour ? 'grey1' : 'white'}
          />
        ))}
      </CardCarouselWrapper>
    </Section>
  );
};
